import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import {
  AddReasonAction,
  UpdateReasonAction,
} from "store/middlewares/dataManagement/activityReason";
import { SubmitLoaderButton } from "components/atoms";

function ModalEditActivityReason({ row, type = "delete", onSuccess }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  const handleSubmit = (values) => {
    let tempObj = {
      enName: values.enName.trim(),
      arName: values.arName.trim(),
      type: type,
    };

    if (row) {
      tempObj = { ...tempObj, id: row?.id };
      dispatch(
        UpdateReasonAction({
          ...tempObj,
          onSuccess: () => {
            formik.setSubmitting(false);
            onSuccess?.();
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    } else {
      dispatch(
        AddReasonAction({
          ...tempObj,
          onSuccess: () => {
            formik.setSubmitting(false);
            onSuccess?.();
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      enName: row?.en_name || "",
      arName: row?.ar_name || "",
      type: type,
    },
    validationSchema: Yup.object({
      enName: Yup.string()
        .required("English title is required")
        .min(3, "Minimum 3 characters required"),
      arName: Yup.string()
        .required("Arabic title is required")
        .min(3, "Minimum 3 characters required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  const getModalTitle = () => {
    switch (type) {
      case "delete":
        return "Delete Reason";
      case "blocked":
        return "Block Reason";
      default:
        return "Reason";
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>{getModalTitle()}</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">Title (English)</Label>
              <Input
                error={formik.errors.enName && formik.touched.enName}
                errorMsg={formik.errors.enName}
                value={formik.values.enName}
                type="text"
                name="enName"
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter english title"
                className={"!py-0 w-full"}
                maxLength={50}
              />
            </div>

            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">Title (Arabic)</Label>
              <Input
                error={formik.errors.arName && formik.touched.arName}
                errorMsg={formik.errors.arName}
                value={formik.values.arName}
                type="text"
                name="arName"
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter arabic title"
                className={"!py-0 w-full"}
                maxLength={50}
              />
            </div>

            <div className="flex justify-center">
              <SubmitLoaderButton
                btnText={row ? "Update" : "Submit"}
                isDisable={formik.isSubmitting && !formError}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditActivityReason;
